function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2FAFF",
  fillOpacity: 0.9,
  d: "M26.5 10C25.6716 10 25 9.32843 25 8.5C25 7.67157 24.3284 7 23.5 7H6C4.89543 7 4 7.89543 4 9V23C4 24.1046 4.89543 25 6 25H26C27.1046 25 28 24.1046 28 23V11.5C28 10.6716 27.3284 10 26.5 10ZM19 9.25C19 8.83579 19.3358 8.5 19.75 8.5H22.75C23.1642 8.5 23.5 8.83579 23.5 9.25C23.5 9.66421 23.1642 10 22.75 10H19.75C19.3358 10 19 9.66421 19 9.25ZM13 9.25C13 8.83579 13.3358 8.5 13.75 8.5H16.75C17.1642 8.5 17.5 8.83579 17.5 9.25C17.5 9.66421 17.1642 10 16.75 10H13.75C13.3358 10 13 9.66421 13 9.25ZM26.5 21.5C26.5 22.6046 25.6046 23.5 24.5 23.5H7.5C6.39543 23.5 5.5 22.6046 5.5 21.5V10.5C5.5 9.39543 6.39543 8.5 7.5 8.5H10C10.8284 8.5 11.5 9.17157 11.5 10C11.5 10.8284 12.1716 11.5 13 11.5H24.5C25.6046 11.5 26.5 12.3954 26.5 13.5V21.5Z"
});

function SvgTabs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabs);
export default __webpack_public_path__ + "static/media/tabs.d916c1d4.svg";
export { ForwardRef as ReactComponent };